module.exports = __webpack_public_path__ + "static/media/1015777.39487745.png";